import { IReducersMap, reducer } from '../../standard-actions/';
import {
    CHANNEL_CARE_LOAD_CASES,
    CHANNEL_CARE_LOAD_CASES_INT,
    CHANNEL_CARE_LOAD_SUMMARY,
    CHANNEL_CARE_SUMBIT_ENQUIRY,
    CHANNEL_CARE_LOAD_CASE_DETAILS,
    CHANNEL_CARE_LOAD_CASE_ACTIVITY,
    CHANNEL_CARE_ADD_COMMENT,
    CHANNEL_CARE_LOAD_ACCOUNT_NUMBERS,
    TICKET_FILE_UPLOAD,
    CHANNEL_CARE_LOAD_COMPANY_IDS,
    BILLING_LOAD_ADJUSTMENT_LIST,
    BILLING_LOAD_INVOICES_LIST,
    CHANNEL_CARE_LOAD_FORM_CONFIG,
    CHANNEL_CARE_SUBMIT_FORM_DATA,
    CHANNEL_CARE_LOAD_CUSTOMER_CONTACT_DATA,
    CHANNEL_CARE_LOAD_ATTACHMENTS,
    CHANNEL_CARE_LOAD_ORDER_REF,
    CHANNEL_CARE_UPDATE_SORTING,
    CHANNEL_CARE_LIST_FILTER,
    CHANNEL_CARE_STORE_FILTER,
    CHANNEL_CARE_LOAD_COMPANY_MULTI_CIDN,
    CHANNEL_CARE_UPDATE_COMPANY_ID,
    CHANNEL_CARE_LOAD_COMPANIES,
    CHANNEL_CARE_LOAD_SUMMARY_CASES
} from '../actions/action-types';

import { IChannelCareState } from '../state';
import { initialState } from '../state/initial-state';
import { loadCasesReducer, LoadCasesAction } from './load-cases';
import { loadCasesReducerInt, LoadCasesActionInt } from './load-cases-int';
import { loadSummaryReducer, LoadSummaryAction } from './load-summary';
import { loadSummaryCasesReducer, LoadSummaryCasesAction } from './load-summary-cases';
import { submitEnquiryReducer, SubmitEnquiryAction } from './submit-enquiry';
import { loadCaseDetailsReducer, LoadCaseDetailsAction } from './load-case-details'
import { loadCaseActivityReducer, LoadCaseActivityAction } from './load-case-activity'
import { addCommentReducer, AddCommentAction } from './add-comment'
import { loadAccountsReducer, LoadAccountsAction } from './load-accounts'
import { fileUploadTicketReducer, FileUploadTicketAction } from './file-upload-reducer';
import { LoadCompanyReducer, LoadCompanysAction } from './load-company'
import { LoadOrderRefrencesReducer, LoadOrderRefrencesAction } from './load-order-refrences'
import { loadAdjustmentListReducer, LoadAdjustmentListAction } from './load-adjustment-list'
import { loadInvoiceReducer, LoadInvoiceAction } from './load-invoices';
import { LoadFormConfigReducer, LoadFormConfigAction } from './load-form-config';
import { submitFormReducer, SubmitFormAction } from './submit-form-data';
import { LoadCustomerContactReducer, LoadCustomerContactAction } from './load-customer-contact';
import { loadCaseAttachmentReducer, LoadCaseAttachmentAction } from './load-attachments'
import { updateSortingReducer } from './common';
import { ILoadCasesFilterSuccessAction, IStoreSFSuccessAction } from '../actions/load-cases';
import { filterSuccessReducer, storeFilterSuccessReducer } from './load-cases-filter';
import { loadCompanyMultiCidnReducer , LoadCompanyMultiCidnAction } from './load-company-multi-cidn';
import { updateCompanyIdReducer , UpdateCompanyIdAction } from './updated-company-id';
import { LoadCompaniesReducer, LoadCompaniesAction } from './load-companies';

export type ChannelCareAction =
    | LoadCasesAction
    | LoadCasesActionInt
    | SubmitEnquiryAction
    | LoadSummaryAction
    | LoadCaseDetailsAction
    | LoadCaseActivityAction
    | AddCommentAction
    | LoadAccountsAction
    | FileUploadTicketAction
    | LoadCompanysAction
    | LoadAdjustmentListAction
    | LoadInvoiceAction
    | LoadFormConfigAction
    | SubmitFormAction
    | LoadCustomerContactAction
    | LoadCaseAttachmentAction
    | LoadOrderRefrencesAction
    | ILoadCasesFilterSuccessAction
    | IStoreSFSuccessAction
    | LoadCompanyMultiCidnAction
    | UpdateCompanyIdAction
    | LoadCompaniesAction
    | LoadSummaryCasesAction

const reducersMap: IReducersMap<IChannelCareState> = {
    [CHANNEL_CARE_LOAD_CASES]: loadCasesReducer,
    [CHANNEL_CARE_LOAD_CASES_INT]: loadCasesReducerInt,
    [CHANNEL_CARE_LOAD_SUMMARY]: loadSummaryReducer,
    [CHANNEL_CARE_SUMBIT_ENQUIRY]: submitEnquiryReducer,
    [CHANNEL_CARE_LOAD_CASE_DETAILS]: loadCaseDetailsReducer,
    [CHANNEL_CARE_LOAD_CASE_ACTIVITY]: loadCaseActivityReducer,
    [CHANNEL_CARE_ADD_COMMENT]: addCommentReducer,
    [CHANNEL_CARE_LOAD_ACCOUNT_NUMBERS]: loadAccountsReducer,
    [TICKET_FILE_UPLOAD]: fileUploadTicketReducer,
    [CHANNEL_CARE_LOAD_COMPANY_IDS]: LoadCompanyReducer,
    [CHANNEL_CARE_LOAD_ORDER_REF]: LoadOrderRefrencesReducer,
    [BILLING_LOAD_ADJUSTMENT_LIST]: loadAdjustmentListReducer,
    [BILLING_LOAD_INVOICES_LIST]: loadInvoiceReducer,
    [CHANNEL_CARE_LOAD_FORM_CONFIG]: LoadFormConfigReducer,
    [CHANNEL_CARE_SUBMIT_FORM_DATA]: submitFormReducer,
    [CHANNEL_CARE_LOAD_CUSTOMER_CONTACT_DATA]: LoadCustomerContactReducer,
    [CHANNEL_CARE_LOAD_ATTACHMENTS]: loadCaseAttachmentReducer,
    [CHANNEL_CARE_UPDATE_SORTING]: updateSortingReducer,
    [CHANNEL_CARE_LIST_FILTER]: filterSuccessReducer,
    [CHANNEL_CARE_STORE_FILTER]: storeFilterSuccessReducer,
    [CHANNEL_CARE_LOAD_COMPANY_MULTI_CIDN]: loadCompanyMultiCidnReducer,
    [CHANNEL_CARE_UPDATE_COMPANY_ID]: updateCompanyIdReducer,
    [CHANNEL_CARE_LOAD_COMPANIES]: LoadCompaniesReducer,
    [CHANNEL_CARE_LOAD_SUMMARY_CASES]: loadSummaryCasesReducer,

};

export type TReducers = (state: IChannelCareState, action: ChannelCareAction) => IChannelCareState;
export const channelCareReducer: TReducers = reducer<IChannelCareState, ChannelCareAction>
(reducersMap, initialState);
